import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { BookingStartRequest } from "use-smart-locks-shared";
import { unlockLocksOfBooking } from "../../shared/api/nest-api";

type MutationArgs = {
  bookingId: string;
  payload?: BookingStartRequest;
};

export function useUnlockLocksOfBookingMutation(
  options?: Omit<
    UseMutationOptions<
      Awaited<ReturnType<typeof unlockLocksOfBooking>>,
      Error,
      MutationArgs
    >,
    "mutationFn"
  >,
) {
  return useMutation({
    mutationFn: ({ bookingId, payload }: MutationArgs) =>
      unlockLocksOfBooking(bookingId, payload),
    ...options,
  });
}
